// PostHog analytics (project "Paid Leadgen"). Anonymous visitors only: no identify, typed form values are
// masked in recordings, and events carry form/field names and outcomes, never what a visitor typed.
// Tag options: data-site (default: hostname), data-funnel (default "site"), data-record="all" to record every visit
// (otherwise the project's 10% replay sample applies).
!function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister identify reset get_distinct_id get_session_id get_session_replay_url set_config startSessionRecording stopSessionRecording sessionRecordingStarted opt_in_capturing opt_out_capturing".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
(function () {
  var d = (document.currentScript && document.currentScript.dataset) || {};
  // array.js replaces the window.posthog stub once loaded, so always resolve it at call time.
  function cap(name, props) { window.posthog.capture(name, props); }
  window.posthog.init("phc_m4vLNArLeffEqBkVW4FpssEcAXNjX6g4wdW4R3WDy5rU", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageleave: true,
    session_recording: { maskAllInputs: true },
    loaded: function (p) { if (d.record === "all") p.startSessionRecording(true); }
  });
  window.posthog.register({ site: d.site || location.hostname.replace(/^www\./, ""), funnel: d.funnel || "site" });

  // Per-step form events: started, each field completed (field name only), submit clicked, submit result.
  function formName(f) { return f.getAttribute("data-ph-form") || f.getAttribute("name") || f.getAttribute("id") || (f.getAttribute("action") || "").split("?")[0] || "form"; }
  function base(f) { return { form: formName(f), path: location.pathname }; }
  var started = [];
  document.addEventListener("focusin", function (e) {
    var f = e.target && e.target.form;
    if (f && started.indexOf(f) < 0) { started.push(f); cap("form_started", base(f)); }
  }, true);
  document.addEventListener("change", function (e) {
    var el = e.target, f = el && el.form;
    if (!f || !el.name || el.type === "hidden") return;
    var props = base(f); props.field = el.name;
    cap("form_field_completed", props);
  }, true);
  var lastSubmit = 0;
  document.addEventListener("submit", function (e) { lastSubmit = Date.now(); cap("form_submit_clicked", base(e.target)); }, true);
  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href^="tel:"]');
    if (a) cap("call_clicked", { path: location.pathname });
  }, true);
  var nativeFetch = window.fetch;
  if (nativeFetch) window.fetch = function (input, init) {
    var res = nativeFetch.apply(this, arguments);
    try {
      var method = (init && init.method) || (input && input.method) || "GET";
      var u = new URL(typeof input === "string" ? input : (input && input.url) || String(input), location.href);
      // Only form posts: right after a submit, or a lead-style endpoint. Beacons like /api/call-click or /api/event are skipped.
      var formish = Date.now() - lastSubmit < 15000 || /lead|inquir|submit|contact|signup|onboard|optin/i.test(u.pathname);
      if (/^post$/i.test(method) && u.origin === location.origin && formish && !/call-click|\/event\b|address-/i.test(u.pathname)) {
        res.then(function (r) { cap("form_submit_result", { endpoint: u.pathname, ok: r.ok, status: r.status, path: location.pathname }); },
                 function () { cap("form_submit_result", { endpoint: u.pathname, ok: false, status: 0, path: location.pathname }); });
      }
    } catch (x) {}
    return res;
  };
})();
